import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormWithProvider from 'components/forms/form/Form';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import useFetchAssistProperties from '../useFetchAssistProperties';
import {
  AssistPropertiesSelectFormValues,
  assistPropertiesSelectSchema,
  getFormDefaultValues,
} from './AssistPropertiesSelectModal.schema';
import AssistPropertiesSelectModalFooter from './AssistPropertiesSelectModalFooter';
import AssistPropertiesSelectTable from './AssistPropertiesSelectTable';

export const ASSIST_PROPERTIES_SELECT_MODAL_ID =
  'assist-properties-select-modal';

interface AssistPropertiesSelectModalProps {
  selectedProperties: string[];
  onUpdate: (properties: string[]) => void;
}

const AssistPropertiesSelectModal = ({
  selectedProperties,
  onUpdate,
}: AssistPropertiesSelectModalProps) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();
  const modalId = useModalId();
  const { allProperties, isFetching } = useFetchAssistProperties();

  if (isFetching) {
    return <LoadingPlaceholder />;
  }

  const properties = allProperties ?? [];

  const handleSubmit = ({
    properties: checkedProperties,
  }: AssistPropertiesSelectFormValues) => {
    onUpdate(
      Object.entries(checkedProperties)
        .filter(([, isChecked]) => isChecked)
        .map(([uid]) => uid),
    );

    closeModal(modalId);
  };

  return (
    <FormWithProvider
      onSubmit={handleSubmit}
      schema={assistPropertiesSelectSchema(properties)}
      defaultValues={getFormDefaultValues({ properties, selectedProperties })}
    >
      <Modal.Body>
        <p>
          {t('pageHostfullyAssist.details.propertiesSelectModal.description')}
        </p>
        <AssistPropertiesSelectTable properties={properties} />
      </Modal.Body>
      <AssistPropertiesSelectModalFooter />
    </FormWithProvider>
  );
};

export default AssistPropertiesSelectModal;
